export interface VideoItem {
  id: string;
  title: string;
  description: string;
  platform: 'youtube' | 'tiktok';
  videoId: string;
  thumbnail: string;
  /** Must match one of the filter slugs: 'walkaround' | 'test-drive' | 'features' | 'customer-story' */
  category: string;
  year: number;
  make: string;
  model: string;
  duration: string;
  /** Raw view count as a number — format for display with .toLocaleString() */
  views: number;
  publishedDate: string;
  featured?: boolean;
}

/**
 * These slugs must stay in sync with the categories array in videos/page.tsx.
 * Format: all lowercase, hyphen-separated — the VideoFilters component formats
 * them for display (e.g. 'test-drive' → 'Test Drive').
 */
export const videoCategories = [
  'all',
  'walkaround',
  'test-drive',
  'features',
  'customer-story',
];

export const videosMock: VideoItem[] = [
  {
    id: 'rh-001',
    title: '2021 Toyota Tacoma TRD Off-Road – Full Walkaround & Honest Review',
    description:
      "Bald Guy #1 walks every inch of this Tacoma — undercarriage, bed liner, tech stack, all four corners. No dealer spin, just the real condition report so you know exactly what you're getting before you drive from Portland.",
    platform: 'youtube',
    // Replace with real Rockhound Auto YouTube video ID
    videoId: 'ScMzIvxBSi4',
    thumbnail: 'https://img.youtube.com/vi/ScMzIvxBSi4/maxresdefault.jpg',
    category: 'walkaround',
    year: 2021,
    make: 'Toyota',
    model: 'Tacoma',
    duration: '11:42',
    views: 1204,
    publishedDate: '2025-11-12',
    featured: true,
  },
  {
    id: 'rh-002',
    title: '2022 Subaru Outback Wilderness – Oregon Coast Test Drive',
    description:
      "We take this Outback Wilderness out on 101 and up through the Coast Range. Rain, gravel shoulder, and a quick forest road section — the full Oregon Coast commuter test. Watch before you schedule yours.",
    platform: 'youtube',
    // Replace with real Rockhound Auto YouTube video ID
    videoId: 'jBHxiHRJgYk',
    thumbnail: 'https://img.youtube.com/vi/jBHxiHRJgYk/maxresdefault.jpg',
    category: 'test-drive',
    year: 2022,
    make: 'Subaru',
    model: 'Outback',
    duration: '8:17',
    views: 873,
    publishedDate: '2025-12-04',
    featured: false,
  },
  {
    id: 'rh-003',
    title: '5 Things Dealers Won\'t Tell You About Certified Pre-Owned Programs',
    description:
      "CPO sounds safe. It usually isn't. We break down what the warranty actually covers, why the \"inspection\" checklist is mostly theater, and what to check yourself before you sign. Three minutes that could save you $3,000.",
    platform: 'youtube',
    // Replace with real Rockhound Auto YouTube video ID
    videoId: 'W0LHTWG-UmQ',
    thumbnail: 'https://img.youtube.com/vi/W0LHTWG-UmQ/maxresdefault.jpg',
    category: 'features',
    year: 2025,
    make: '',
    model: '',
    duration: '3:58',
    views: 2441,
    publishedDate: '2026-01-22',
    featured: false,
  },
  {
    id: 'rh-004',
    title: 'From Skeptic to Sold: How Sarah From Astoria Bought Her First Car Without a Dealership',
    description:
      "Sarah drove 2 hours to dealerships in Portland twice and left both times feeling pressured and confused. Then she called us. Watch how the whole thing went — from her first message to picking up her 2020 CR-V in Warrenton. No pressure, no surprise fees, no regrets.",
    platform: 'youtube',
    // Replace with real Rockhound Auto YouTube video ID
    videoId: 'dQw4w9WgXcQ',
    thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
    category: 'customer-story',
    year: 2020,
    make: 'Honda',
    model: 'CR-V',
    duration: '6:14',
    views: 3887,
    publishedDate: '2026-02-08',
    featured: false,
  },
];